import React, { useState, useContext, useEffect } from 'react'
import swal from 'sweetalert'
import { getMunicipios } from '../../services/leadMunicipiosService'
import CampanasPage from '../../pages/LeadsPage/CampanasPage/CampanasPage'

import { permitsList, swalMessages } from '../../constants'
import { Context } from '../../context/Contex'

import { getVehiculos } from '../../services/vehiculosService'
import { getDepartamentos } from '../../services/leadDepartamentosService'
import {
  getEstablecimiento,
  getEstablecimientoActivo,
  getEstablecimientosByMunicipio,
} from '../../services/establecimientosService'
import {
  getCampana,
  postCampana,
  putCampana,
  deleteCampana,
  getCampanaBy,
} from '../../services/campanasLeadsService'

const searchArray = {
  ciudad: null,
  estado: null,
  impulsa: null,
  estrategia: null,
  departamento: null,
  linea: null,
}

const initialForm = {
  nombre_campana: '',
  estado_global: 0,
  estado: 1,
  fechaInicial: '',
  fechaFinal: '',
  campanasCiudades: [],
  campanasVehiculos: [],
  campanasEstablecimientos: [],
}

const initialControls = {
  ciudadControl: [],
  vehiculosControl: [],
  establecimientosControl: [],
  fechaInicialControl: '',
  fechaFinalControl: '',
  estadoGlobalControl: 0,
}

const CampanasContainer = () => {
  const [details, setDetails] = useState({})
  const [isEdit, setIsEdit] = useState(false)
  const [form, setForm] = useState(initialForm)
  const [vehiculos, setVehiculos] = useState([])
  const [municipios, setMunicipios] = useState([])
  const [establecimientos, setEstablecimientos] = useState([])
  const [
    establecimientosCampanasNew,
    setEstablecimientosCampanasNew,
  ] = useState([])
  const [filterArray, setFilterArray] = useState([])
  const [openDetails, setOpenDetails] = useState(false)
  const [openAddForm, setOpenAddForm] = useState(false)
  const [openAddFormCampaign, setOpenAddFormCampaign] = useState(false)
  const [departamentos, setDepartamentos] = useState([])
  const [filteredCities, setFilteredCities] = useState([])
  const [controls, setControls] = useState(initialControls)
  const [campanas, setCampanas] = useState([])
  const [data, setData] = useState([])
  const { permisos } = useContext(Context)
  const permitValue = permisos[permitsList.LEADS_ADMIN]
  const [sections, setSections] = useState([])

  const today = new Date()
  // Get year, month, and day components
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0') // Months are zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, '0')

  // Concatenate components to form the desired format
  const formattedDate = `${year}/${month}/${day}`

  const [selectedDateInit, setSelectedDateInit] = useState(
    new Date(formattedDate).toString(),
  )

  const [selectedDateEnd, setSelectedDateEnd] = useState(
    new Date(formattedDate).toString(),
  )

  const fetchCampana = async () => {
    const { success, data } = await getCampana()
    if (success) {
      //console.log(data, 'data')
      setCampanas(data)
      setFilterArray(data)
    } else {
      console.log('error')
    }
  }

  const fetchEstablecimiento = async () => {
    const { success, data } = await getEstablecimientoActivo()
    if (success) {
      setEstablecimientos(data)
      // setFilterArray(data);
    } else {
      console.log('error')
    }
  }

  const fetchVehiculos = async () => {
    const { success, data } = await getVehiculos()
    if (success) {
      setVehiculos(data)
    } else {
      console.log('error')
    }
  }

  const fetchDepartamentos = async () => {
    const { success, data } = await getDepartamentos()
    if (success) {
      setDepartamentos(data)
    } else {
      console.log('error')
    }
  }

  const fetchMunicipios = async () => {
    const { success, data } = await getMunicipios()
    if (success) {
      const sortCity = data.sort((a, b) => {
        if (a.NOMBRE_MPI > b.NOMBRE_MPI) {
          return 1
        }
        if (a.NOMBRE_MPI < b.NOMBRE_MPI) {
          return -1
        }
        return 0
      })
      setMunicipios(sortCity)
    } else {
      console.log('error')
    }
  }

  const filterSocios = ({ socio, param, value }) => {
    const empty = !value || value === '0'
    switch (param) {
      case 'linea': {
        const brand = (socio.establecimientoVehiculos || []).map(
          (marca) => marca.nombre_vehiculo,
        )
        return brand.includes(value) || empty
      }
      case 'estado': {
        const estado = value === 'SI' ? '1' : '0'
        return socio[param] === estado || empty
      }
      case 'impulsa': {
        const estado = value === 'SI' ? '1' : '0'
        return socio[param] === estado || empty
      }
      default: {
        const validSocio = String(socio[param]) === value
        return validSocio || empty
      }
    }
  }

  const formatDate = (date) => {
    // Convert to Date object
    const dateObj = new Date(date)

    // Adjust for UTC timezone
    dateObj.setHours(dateObj.getHours() - 8) // Assuming the original timestamp is in UTC

    // Adjust the date to the previous day (if needed)
    dateObj.setDate(dateObj.getDate() - 1)

    // Format the date and time components
    const formattedDateTime = dateObj
      .toISOString()
      .replace('T', ' ')
      .slice(0, 19)

    return formattedDateTime
  }

  /** metodo de los filtros */
  const handleChange = (filter, value) => {
    Object.assign(searchArray, { [filter]: value })
    const updatedSocios = Object.keys(searchArray).reduce(
      (reducedSocios, filterKey) => {
        reducedSocios = reducedSocios.filter((socio) =>
          filterSocios({
            socio,
            param: filterKey,
            value: searchArray[filterKey],
          }),
        )
        return reducedSocios
      },
      campanas,
    )
    setFilterArray(updatedSocios)
  }

  const handleChangeDepartment = (key, value) => {
    setFilteredCities([])
    const newCiudades = municipios
    let result = []
    Object.assign(searchArray, { ciudad: null })
    if (key === 'departamento' && value != '0') {
      result = newCiudades?.filter((item) => {
        if (item.NOMBRE_DPT === value) {
          return item
        }
      })
    }
    const sortCity = result.sort((a, b) => {
      if (a.NOMBRE_MPI > b.NOMBRE_MPI) {
        return 1
      }
      if (a.NOMBRE_MPI < b.NOMBRE_MPI) {
        return -1
      }
      return 0
    })
    handleChange(key, value)
    setFilteredCities(sortCity)
  }
  // peticiones API
  const handleSubmit = async (e) => {
    e.preventDefault()
    setOpenAddForm(false)
    if (isEdit) {
      //console.log(form, 'form')
      const { success } = await putCampana({
        ...form,
      })
      if (success) {
        fetchCampana()
        swal(swalMessages.SUCCESSFUL_MESSAGE)
      } else {
        swal(swalMessages.GENERAL_ERROR)
      }
    } else {
      const { id, success } = await postCampana({
        ...form,
      })

      if (id && success) {
        fetchCampana()
        swal(swalMessages.SUCCESSFUL_MESSAGE)
      } else {
        swal(swalMessages.GENERAL_ERROR)
      }
    }
    // console.log(form, 'form')
    setIsEdit(false)
    setForm(initialForm)
    setControls(initialControls)
    handleChange('lineas', '')
  }

  const handleDelete = async (rowData) => {
    swal(swalMessages.DELETE_CONFIRM).then((willDelete) => {
      if (willDelete) {
        console.log(rowData.id)
        const response = deleteCampana(rowData.id)
        if (response) {
          const updated = campanas.filter(
            (campana) => campana.id !== rowData.id,
          )
          const updatedCampanas = filterArray.filter(
            (campana) => campana.id !== rowData.id,
          )
          setFilterArray(updatedCampanas)
          setCampanas(updated)
        } else {
          swal(swalMessages.GENERAL_ERROR)
        }
      }
    })
  }

  const dobleCheck = (array, principal, secundary) => {
    if (principal !== 'nombre_ciudad') {
      const firstResult = array?.map((item) => ({
        label: item[principal],
        value: item[secundary],
      }))
      const secondResult = array?.map((item) => Number(item[secundary]))
      return { firstResult, secondResult }
    }
    const firstResult = array?.map((item) => ({
      label: `${item[principal]} (${item[secundary]})`,
      value: item[principal],
    }))
    const secondResult = array?.map((item) => ({
      ciudad: item[principal],
      departamento: item[secundary],
    }))
    return { firstResult, secondResult }
  }

  const dobleCheckTree = (array, principal, secundary, tercero, cuarto) => {
    //console.log(array, 'array')
    const firstResult = array?.map((item) => ({
      label: `${item[principal]}`,
      value: item[secundary],
      value2: item[tercero],
      value3: item[cuarto],
    }))
    const secondResult = array?.map((item) => Number(item[cuarto]))
    return { firstResult, secondResult }
  }

  const fetchEstablecimientosMunicipios = async (value, id) => {
    //setEstablecimientosCampanasNew([])
    const { success, data } = await getEstablecimientosByMunicipio(value)
    if (success) {
      //console.log(id)
      //console.log(value)
      console.log(sections, 'sections')
      /*const sortCity = data.sort((a, b) => {
        if (a.NOMBRE_MPI > b.NOMBRE_MPI) {
          return 1
        }
        if (a.NOMBRE_MPI < b.NOMBRE_MPI) {
          return -1
        }
        return 0
      })*/
      //console.log(typeof(data), 'data')
      setEstablecimientosCampanasNew(JSON.parse(data))
    } else {
      console.log('error')
    }
  }

  // Control INPUTS
  const onChangeInputs = (value, field) => {
    //console.log(value, field, 'value')
    switch (field) {
      case 'estado_global':
        {
          //console.log(value, 'value info')
          setForm({ ...form, [field]: value })
          setControls({ ...controls, estadoGlobalControl: value })
        }
        break
      case 'campanasCiudades':
        {
          const valuesTo = value.map((item) => ({
            ciudad: item.value,
            departamento: item.value2,
          }))
          // console.log(valuesTo, 'valuesToCiudades')
          setForm({ ...form, [field]: valuesTo })
          setControls({ ...controls, ciudadControl: value })
        }
        break
      case 'campanasVehiculos':
        {
          const valuesTo = dobleCheck(value, 'label', 'value')
          //console.log(valuesTo, 'valuesToVehiculos')
          setForm({ ...form, [field]: valuesTo.secondResult })
          setControls({ ...controls, vehiculosControl: value })
        }
        break
      case 'campanasEstablecimientos':
        {
          //console.log(value, 'value')
          const valuesTo = dobleCheckTree(
            value,
            'label',
            'value',
            'value2',
            'value3',
          )
          //console.log(valuesTo, 'valuesTo establecimientos')
          setForm({ ...form, [field]: valuesTo.secondResult })
          setControls({ ...controls, establecimientosControl: value })
        }
        break
      case 'fechaInicial':
        {
          const valuesTo = value.toISOString()
          setSelectedDateInit(formatDate(valuesTo))
          setForm({ ...form, [field]: formatDate(valuesTo) })
          setControls({ ...controls, fechaInicialControl: value })
        }
        break
      case 'fechaFinal':
        {
          const valuesTo = value.toISOString()
          setSelectedDateEnd(formatDate(valuesTo))
          setForm({ ...form, [field]: formatDate(valuesTo) })
          setControls({ ...controls, fechaFinalControl: value })
        }
        break
      default:
        setForm({ ...form, [field]: value })
        break
    }
  }

  // Control New imnputs
  const onChangeInputsNew = (value, field, id) => {
    //console.log(data, 'data')
    switch (field) {
      case 'campanasCiudades':
        {
          //console.log(data, 'data')

          const valuesTo = {
            id: id,
            ciudad: value.NOMBRE_MPI,
            departamento: value.NOMBRE_DPT,
          }

          const updatedSections = [...sections, valuesTo]
          const array = []
          array.push(updatedSections)

          setSections(array)
          fetchEstablecimientosMunicipios(valuesTo, id)
          /*setData(prevData => {
            const newData = { ...prevData };
            newData[field] = valuesTo;
            return newData;
          })
          console.log(data, 'data')*/

          //setControls({ ...controls, estadoGlobalControl: value })
        }
        break
      default:
        setForm({ ...form, [field]: [value] })
        break
    }
  }

  // open and Close modal
  const onOpenForm = (evento, data) => {
    if (evento === 'edit') {
      const rowSelected = campanas
        .filter((campana) => campana.id === data.id)
        .pop()

      const establecimientos = dobleCheckTree(
        rowSelected.campanasEstablecimientos,
        'nombre_establecimiento_ciudad',
        'nombre_establecimiento',
        'ciudad',
        'id_establecimiento',
      )
      const stockCiudades = dobleCheck(
        rowSelected.campanasCiudades,
        'nombre_ciudad',
        'nombre_departamento',
      )
      const stockVehiculos = dobleCheck(
        rowSelected.campanasVehiculos,
        'linea',
        'id_vehiculo',
      )

      setControls({
        ...controls,
        ciudadControl: stockCiudades.firstResult,
        vehiculosControl: stockVehiculos.firstResult,
        establecimientosControl: establecimientos.firstResult,
        estadoGlobalControl: Number(rowSelected.estado_global),
      })
      setForm({
        ...rowSelected,
        campanasCiudades: stockCiudades.secondResult,
        campanasVehiculos: stockVehiculos.secondResult,
        campanasEstablecimientos: establecimientos.secondResult,
        estadoGlobalControl: Number(rowSelected.estado_global),
      })
      setIsEdit(true)
    }
    setOpenAddForm(true)
  }

  // open and Close modal
  const onOpenFormCampaing = (evento, data) => {
    if (evento === 'edit') {
      const rowSelected = campanas
        .filter((campana) => campana.id === data.id)
        .pop()

      const establecimientos = dobleCheckTree(
        rowSelected.campanasEstablecimientos,
        'nombre_establecimiento_ciudad',
        'nombre_establecimiento',
        'ciudad',
        'id_establecimiento',
      )
      const stockCiudades = dobleCheck(
        rowSelected.campanasCiudades,
        'nombre_ciudad',
        'nombre_departamento',
      )
      const stockVehiculos = dobleCheck(
        rowSelected.campanasVehiculos,
        'linea',
        'id_vehiculo',
      )

      //console.log(establecimientos, 'establecimientos');
      //console.log(stockCiudades, 'ciudades');
      //console.log(stockVehiculos, 'vehiculos');
      //console.log(establecimientos, 'establecimientos');

      setControls({
        ...controls,
        ciudadControl: stockCiudades.firstResult,
        vehiculosControl: stockVehiculos.firstResult,
        establecimientosControl: establecimientos.firstResult,
        estadoGlobalControl: Number(rowSelected.estado_global),
      })
      setForm({
        ...rowSelected,
        campanasCiudades: stockCiudades.secondResult,
        campanasVehiculos: stockVehiculos.secondResult,
        campanasEstablecimientos: establecimientos.secondResult,
        estadoGlobalControl: Number(rowSelected.estado_global),
      })
      setIsEdit(true)
    }
    setOpenAddFormCampaign(true)
  }

  const onCloseForm = () => {
    setIsEdit(false)
    setControls(initialControls)
    setOpenAddForm(false)
    setForm(initialForm)
    setOpenDetails(false)
  }

  const onCloseFormCampaign = () => {
    setIsEdit(false)
    setControls(initialControls)
    setOpenAddFormCampaign(false)
    setForm(initialForm)
    setOpenDetails(false)
  }

  const onOpenDetails = (rowData) => {
    setOpenDetails(true)
    setDetails(rowData)
  }

  useEffect(() => {
    fetchVehiculos()
    fetchMunicipios()
    fetchDepartamentos()
    fetchCampana()
    fetchEstablecimiento()
  }, [])

  return (
    <CampanasPage
      form={form}
      isEdit={isEdit}
      details={details}
      controls={controls}
      ciudades={municipios}
      vehiculos={vehiculos}
      onOpenForm={onOpenForm}
      onOpenFormCampaing={onOpenFormCampaing}
      onCloseForm={onCloseForm}
      onCloseFormCampaign={onCloseFormCampaign}
      openAddForm={openAddForm}
      openAddFormCampaign={openAddFormCampaign}
      permitValue={permitValue}
      openDetails={openDetails}
      handleDelete={handleDelete}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      onOpenDetails={onOpenDetails}
      departamentos={departamentos}
      campanas={filterArray}
      establecimientos={establecimientos}
      establecimientosCampanasNew={establecimientosCampanasNew}
      onChangeInputs={onChangeInputs}
      onChangeInputsNew={onChangeInputsNew}
      filteredCities={filteredCities}
      controlComponent={campanas}
      handleChangeDepartment={handleChangeDepartment}
      selectedDateInit={selectedDateInit}
      selectedDateEnd={selectedDateEnd}
      data={data}
    />
  )
}

export default CampanasContainer
